import { IOptionProps } from '@pnld/components-web'

// O `onChange` do Select entrega `unknown`: a opção escolhida, `null` ao
// limpar o campo ou a lista de opções no modo múltiplo.
export const toSingleOption = (newValue: unknown): IOptionProps | null => {
  if (typeof newValue !== 'object' || newValue === null) return null
  if (!('value' in newValue) || !('label' in newValue)) return null

  const { value, label } = newValue
  const isOption =
    typeof label === 'string' &&
    (typeof value === 'string' || typeof value === 'number')

  return isOption ? (newValue as IOptionProps) : null
}
